<agpr-take-over-panel
    id="quataUdageWidget"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [showFooter]="false"
    class="agpr-quataUdageWidget"
    (closeTakeover)="closeDialog()"
    width="80"
    [noPadding]="true"
    [whiteBg]="true"
    [ariaLabel]="'Social.intelligence.themeManagement.agent' | localize"
>
    <agpr-quota-usage-dashboard
        [expanded]="true"
        [showBanner]="true"
        [showHeader]="true"
        [selectedStartDate]="selectedStartDate"
        [quotaType]="quotaType"
    ></agpr-quota-usage-dashboard>
</agpr-take-over-panel>



